export default "__VITE_ASSET__QCFon5ew__"